import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Rating,
  TextField
} from "@mui/material";
import { getDatabase, ref, push, onValue } from "firebase/database";
import app from "../../../firebaseConfig";
import { LinearProgress } from "@mui/material";


const ResenasProducto = ({ categoria, producto }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [nombre, setNombre] = useState("");
  const [comentario, setComentario] = useState("");
  const [estrellas, setEstrellas] = useState(5);
  const [imagenesLinks, setImagenesLinks] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [imagenAmpliada, setImagenAmpliada] = useState(null);
  const [estadisticas, setEstadisticas] = useState({ promedio: 0, conteos: {} });


  const db = getDatabase(app);
  const comentariosRef = ref(db, `nature/Awoo/Categorias/${categoria}/${producto}/Comentarios`);

  useEffect(() => {
    onValue(comentariosRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const lista = Object.values(data);
        lista.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
        setComentarios(lista);
      } else {
        setComentarios([]);
      }
    });
  }, [categoria, producto]);


  useEffect(() => {
    onValue(comentariosRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const lista = Object.values(data);
        lista.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
        setComentarios(lista);
  
        // Calcular promedio y distribución
        const conteos = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
        let suma = 0;
        lista.forEach(r => {
          const e = r.estrellas || 0;
          conteos[e] = (conteos[e] || 0) + 1;
          suma += e;
        });
        const promedio = lista.length > 0 ? suma / lista.length : 0;
        setEstadisticas({ promedio, conteos });
      } else {
        setComentarios([]);
        setEstadisticas({ promedio: 0, conteos: {} });
      }
    });
  }, [categoria, producto]);
  


  const handleGuardarResena = () => {
    if (!nombre || !comentario || estrellas < 1) return;

    const nuevaResena = {
      nombre,
      comentario,
      estrellas,
      imagenes: imagenesLinks.filter(link => link.trim() !== ""),
      fecha: new Date().toISOString()
    };

    push(comentariosRef, nuevaResena);
    setOpenDialog(false);
    setNombre("");
    setComentario("");
    setEstrellas(5);
    setImagenesLinks([]);
  };

  const agregarCampoImagen = () => {
    setImagenesLinks([...imagenesLinks, ""]);
  };

  const actualizarImagenLink = (index, value) => {
    const nuevas = [...imagenesLinks];
    nuevas[index] = value;
    setImagenesLinks(nuevas);
  };

  const emojiPerfil = "👤";

  return (
    <div style={{ marginTop: "40px" }}>
      <Typography variant="h5" gutterBottom>Reseñas del producto</Typography>

{/* Estadísticas generales de calificación */}
{comentarios.length > 0 && (
  <div style={{ maxWidth: "600px", margin: "0 auto 30px auto" }}>
    <Typography variant="h6" gutterBottom>
      ⭐ {estadisticas.promedio.toFixed(1)} / 5 ({comentarios.length} reseñas)
    </Typography>
    
    {[5, 4, 3, 2, 1].map(num => {
      const count = estadisticas.conteos[num] || 0;
      const percent = ((count / comentarios.length) * 100).toFixed(1);
      return (
        <div key={num} style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
          <Typography style={{ width: 30 }}>{num}</Typography>
          <LinearProgress
            variant="determinate"
            value={parseFloat(percent)}
            style={{ flex: 1, margin: "0 10px", height: 8, borderRadius: 4 }}
            color="primary"
          />
          <Typography variant="body2">{percent}%</Typography>
        </div>
      );
    })}
  </div>
)}


      <Button
        variant="contained"
        style={{ backgroundColor: "#0bbfe3", color: "#fff", marginBottom: "20px" }}
        onClick={() => setOpenDialog(true)}
      >
        ✍️ Escribir una reseña
      </Button>

            {/* Listado de comentarios */}
            {comentarios.length > 0 ? comentarios.map((resena, idx) => (
        <div key={idx} style={{
          maxWidth: "600px",
          margin: "0 auto 30px auto",
          background: "#ffffff",
          padding: "20px",
          borderRadius: "15px",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.2)", // sombra más marcada
          transition: "box-shadow 0.3s"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "10px" }}>
            <div style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#e0e0e0",
              boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              flexShrink: 0
            }}>
              {emojiPerfil}
            </div>
            <div>
              <Typography variant="subtitle1" style={{display: "flex", fontWeight: "bold" }}>
                {resena.nombre}
              </Typography>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Rating value={resena.estrellas} readOnly size="small" />
                <Typography
                  variant="body2"
                  style={{
                    color: "#3aba36",
                    fontStyle: "italic",
                    fontWeight: "bold"
                  }}
                >
                  Compra Verificada
                </Typography>
              </div>
            </div>
          </div>

          <Typography variant="body2" style={{ marginBottom: "8px" }}>
            {resena.comentario}
          </Typography>

          {/* Miniaturas centradas y con scroll horizontal */}
          {resena.imagenes && resena.imagenes.length > 0 && (
            <div style={{
              display: "flex",
              gap: "10px",
              overflowX: "auto",
              marginTop: "15px",
              paddingBottom: "5px",
              justifyContent: "center"
            }}>
              {resena.imagenes.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`img-${i}`}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    cursor: "pointer",
                    border: "1px solid #ccc",
                    flexShrink: 0
                  }}
                  onClick={() => setImagenAmpliada(img)}
                />
              ))}
            </div>
          )}

          <Typography
            variant="caption"
            color="textSecondary"
            style={{ display: "block", marginTop: "8px" }}
          >
            {new Date(resena.fecha).toLocaleString("es-CO")}
          </Typography>
        </div>
      )) : (
        <Typography variant="body2" color="textSecondary">
          Aún no hay reseñas.
        </Typography>
      )}

      {/* Diálogo para nueva reseña */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Escribir Reseña</DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column", gap: "15px", width: "350px" }}>
          <TextField
            label="Tu Nombre"
            variant="outlined"
            fullWidth
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
          <TextField
            label="Comentario"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Typography>Calificación:</Typography>
            <Rating
              value={estrellas}
              onChange={(e, newValue) => setEstrellas(newValue)}
            />
          </div>

          {/* Inputs dinámicos para imágenes */}
          <Button variant="outlined" onClick={agregarCampoImagen}>
            ➕ Agregar imágenes
          </Button>

          {imagenesLinks.map((link, idx) => (
            <TextField
              key={idx}
              label={`Imagen #${idx + 1}`}
              variant="outlined"
              fullWidth
              value={link}
              onChange={(e) => actualizarImagenLink(idx, e.target.value)}
            />
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleGuardarResena} variant="contained" color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialogo para imagen ampliada */}
      <Dialog open={!!imagenAmpliada} onClose={() => setImagenAmpliada(null)} maxWidth="md">
        <img
          src={imagenAmpliada}
          alt="Vista ampliada"
          style={{ width: "100%", height: "auto", maxHeight: "80vh", objectFit: "contain" }}
        />
      </Dialog>
    </div>
  );
};

export default ResenasProducto;
